import React, { useState, useEffect, useContext, forwardRef } from "react";
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material'
import JobFilter from "./JobFilter";
import JobBanner from "./JobBanner";
import JobListing from "./JobListing";
import { DataContext } from "../context/DataContext";
import { CountryDropDown, StateDropDown, CityDropDown, CategoryDropDown, DivisionDropDown, StatusDropDown } from "../GlobalUtilities/DataLists";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';

const JobSection = forwardRef((props, ref) => {

    const params = useParams();
    const [isMobileView, setIsMobileView] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const handleResize = () => {
        setIsMobileView(window.innerWidth < 600);
    };

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
      };

    const { originalJobData, setLocationFilter, countryList, setCountryList, stateList, setStateList, cityList, setCityList, categoryList, setCategoryList, divisionList, setDivisionList, statusList, setStatusList } = useContext(DataContext);

    useEffect(() => {

        handleResize(); // Check initial size
        window.addEventListener('resize', handleResize);

        //Check for needed operational website filter
        if (params.webname) {
            const operationJobs = originalJobData.filter(x => x.websites.some(y => y.startsWith(params.webname)));
            console.log("Operation Jobs: ", operationJobs);
            //setLocationFilter({label: 'Country', value: 'United State'})
            const operationCountries = CountryDropDown({ data: operationJobs });
            const operationStates = StateDropDown({ data: operationJobs });
            const operationCities = CityDropDown({ data: operationJobs });

            const operationLocationFilter = [];

            operationCountries.forEach(x => {
                operationLocationFilter.push({ label: 'Country', value: x.value })
            })

            operationStates.forEach(x => {
                operationLocationFilter.push({ label: 'State', value: x.value })
            })

            operationCities.forEach(x => {
                operationLocationFilter.push({ label: 'City', value: x.value })
            })

            setLocationFilter(operationLocationFilter);

        }
        //Country
        setCountryList(CountryDropDown({ data: originalJobData }));
        //State
        setStateList(StateDropDown({ data: originalJobData }));
        //City
        setCityList(CityDropDown({ data: originalJobData }));
        //Category
        setCategoryList(CategoryDropDown({ data: originalJobData }));
        //Division
        setDivisionList(DivisionDropDown({ data: originalJobData }));
        //Status
        setStatusList(StatusDropDown({ data: originalJobData }));

    }, [originalJobData]);

    if (!statusList) {
        return <div>Loading...</div>
    }

    return (
        <Grid container ref={ref}>
            <Grid item xs={12} sx={{ order: { md: 1, xs: 2 } }}>
                <JobBanner />
            </Grid>
            <Grid item md={3} xs={12} sx={{ order: { md: 1, xs: 1 } }}>
                {isMobileView ? (
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary expandIcon={expanded === 'panel1' ? <Remove /> : <Add />} aria-controls="panel1-content" id="panel1-header">
                            <Typography>Available Job Filters</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <JobFilter title="Country" filterList={countryList} />
                            <JobFilter title="State" filterList={stateList} />
                            <JobFilter title="City" filterList={cityList} />
                            <JobFilter title="Category" filterList={categoryList} />
                            <JobFilter title="Division" filterList={divisionList} />
                            <JobFilter title="Status" filterList={statusList} />
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <>
                        <JobFilter title="Country" filterList={countryList} />
                        <JobFilter title="State" filterList={stateList} />
                        <JobFilter title="City" filterList={cityList} />
                        <JobFilter title="Category" filterList={categoryList} />
                        <JobFilter title="Division" filterList={divisionList} />
                        <JobFilter title="Status" filterList={statusList} />
                    </>
                )}

            </Grid>
            <Grid item md={9} xs={12} sx={{ order: { md: 2, xs: 3 } }}>
                <JobListing />
            </Grid>
        </Grid>
    )
});

export default JobSection;